import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ContactModule } from '../contacts/contact.module';

@NgModule({
  imports: [RouterModule.forChild([
    { path: ':orgId/hierarchy', loadChildren: () => ContactModule }
  ])],
  exports: [RouterModule],
  providers: []
})
export class BusinessGroupsRoutingModule {
}
